module.exports = __webpack_public_path__ + "img/FAQ03.23fdc1ff.png";